import { render, staticRenderFns } from "./SelectPackage.vue?vue&type=template&id=4f8f7cdd&scoped=true"
import script from "./SelectPackage.vue?vue&type=script&lang=js"
export * from "./SelectPackage.vue?vue&type=script&lang=js"
import style0 from "./SelectPackage.vue?vue&type=style&index=0&id=4f8f7cdd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f8f7cdd",
  null
  
)

export default component.exports